import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, formatINR } from "../lib/api";
import { useCart } from "../context/CartContext";
import { Reveal } from "../components/Reveal";
import { ArrowLeft, Plus, Minus } from "lucide-react";
import { toast } from "sonner";

export default function Product() {
  const { slug } = useParams();
  const [product, setProduct] = useState(null);
  const [qty, setQty] = useState(1);
  const { add } = useCart();

  useEffect(() => {
    api.get(`/products/${slug}`).then((r) => setProduct(r.data)).catch(() => {});
  }, [slug]);

  if (!product) return <div className="pt-40 text-center text-mj-muted min-h-screen">Loading…</div>;

  return (
    <div data-testid="product-page" className="pt-32 min-h-screen">
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-32">
        <Link to="/collection" className="inline-flex items-center gap-2 overline text-mj-muted hover:text-mj-red mb-12"><ArrowLeft className="w-4 h-4"/> Back to Collection</Link>
        <div className="grid md:grid-cols-2 gap-12 md:gap-20">
          <Reveal>
            <div className="relative aspect-[3/4] bg-mj-surface border border-mj-border overflow-hidden flex items-center justify-center">
              <span className="font-serif-mj text-mj-gold/30 text-[16rem] leading-none select-none">M</span>
              <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-r from-transparent via-mj-gold to-transparent opacity-60" />
              <div className="absolute bottom-0 left-0 right-0 h-2 bg-gradient-to-r from-transparent via-mj-gold to-transparent opacity-60" />
              <span className="absolute bottom-6 overline text-mj-muted/60">Photo coming soon</span>
            </div>
          </Reveal>
          <div>
            <Reveal><span className="overline text-mj-golddeep">{product.category}</span></Reveal>
            <Reveal delay={0.1}><h1 className="font-serif-mj text-4xl md:text-6xl tracking-tight text-mj-text mt-4 leading-tight">{product.name}</h1></Reveal>
            <Reveal delay={0.15}><p className="font-serif-mj text-3xl text-mj-red mt-6">{formatINR(product.price)}</p></Reveal>
            <Reveal delay={0.2}><p className="font-sans-mj text-mj-muted leading-relaxed mt-8">{product.description}</p></Reveal>
            <Reveal delay={0.25}>
              <div className="grid grid-cols-2 gap-6 mt-10 border-t border-b border-mj-border py-6">
                <div><p className="overline text-mj-muted mb-1">Fabric</p><p className="font-serif-mj text-xl">{product.fabric}</p></div>
                <div><p className="overline text-mj-muted mb-1">Notes</p><p className="font-serif-mj text-xl">{product.color_note}</p></div>
              </div>
            </Reveal>
            <Reveal delay={0.3}>
              <div className="flex items-center gap-6 mt-10">
                <div className="flex items-center border border-mj-border">
                  <button data-testid="qty-dec" onClick={() => setQty(Math.max(1, qty - 1))} className="w-11 h-11 flex items-center justify-center hover:text-mj-red"><Minus className="w-4 h-4"/></button>
                  <span className="w-10 text-center">{qty}</span>
                  <button data-testid="qty-inc" onClick={() => setQty(qty + 1)} className="w-11 h-11 flex items-center justify-center hover:text-mj-red"><Plus className="w-4 h-4"/></button>
                </div>
                <button data-testid="add-to-cart-btn" onClick={() => { add(product, qty); toast.success(`${product.name} added to your selection`); }}
                  className="flex-1 bg-mj-red text-mj-bg py-4 overline hover:bg-mj-reddark transition-colors">Add to Cart</button>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
